import type { HomeWidgetId } from "@heraion/shared";

import type { TFn } from "../i18nTypes";

// HR-11: what the UI needs per Home widget. The ids and the default order
// live in @heraion/shared (homeLayout.ts); this adds the wide-layout column
// and the name the config sheet shows.

/** Wide layout: MAIN is the content stream, RAIL the act-now stream. Order
 *  inside each column follows the athlete's one order list. */
export const HOME_WIDGET_COLUMN: Record<HomeWidgetId, "main" | "rail"> = {
  hero: "main",
  readiness: "rail",
  weeklyTargets: "main",
  quickWeight: "rail",
  quickGlucose: "rail",
  badges: "main",
  coverage: "main",
  e1rmTrends: "main",
  repsAtLoad: "main",
  movementBalance: "main",
  painVolume: "main",
  intensityHeatmap: "main",
  exerciseFrequency: "main",
  painMap: "main",
  measurements: "main",
};

const LABEL: Record<HomeWidgetId, string> = {
  hero: "Today",
  readiness: "Readiness",
  weeklyTargets: "This week",
  quickWeight: "Body weight",
  quickGlucose: "Glucose",
  badges: "Badges",
  coverage: "Muscle coverage",
  e1rmTrends: "E1RM trends",
  repsAtLoad: "Reps at load",
  movementBalance: "Movement balance",
  painVolume: "Pain × volume",
  intensityHeatmap: "Intensity heatmap",
  exerciseFrequency: "Stalest exercises",
  painMap: "Pain map",
  measurements: "Measurements",
};

export function homeWidgetLabel(t: TFn, id: HomeWidgetId): string {
  return t(`mobile.home.config.widget.${id}`, { defaultValue: LABEL[id] });
}
